module.exports = __webpack_public_path__ + "static/media/ny-times.e48b6910.jpg";